import React, { useState, useEffect, ChangeEvent } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import swal from 'sweetalert'
import './style.css';
import Alert from '../../helpers/Alert';

//SERVICES
import { getOsById, updateOs } from '../../services/OsService';

// COMPONENTS
import Template from '../../components/Template';
import Registro from "../../components/Os/Registro";
import RegistroImovel from "../../components/Os/RegistroImovel";
import Pesquisas from "../../components/Os/Pesquisas";
import Entrevista from "../../components/Os/Entrevista";
import Orgaos from "../../components/Os/Orgaos";
import Croqui from "../../components/Os/Croqui";
import VistoriaImovel from "../../components/Os/VistoriaImovel";
import Conclusao from "../../components/Os/Conclusao";
import Despesas from "../../components/Os/Despesas";
import i18n from '../../translate/i18n';



export default function Edit(props: any) {
  let history = useNavigate();

  const [data, setData] = useState<any>({});
  const [stepData, setStepData] = useState<any[]>([]);

  const { id } = useParams()
  const [active, setActive] = useState<number>(1);


  // buscar dados
  useEffect(() => {
    getOsById(id).then(res => {
      if (res.data) {
        const prestador = res.data.prestador.id
        setData({ ...res.data, prestador })
        res.data.finalizado && history('../home')
      }
    }).catch(err => {
      Alert(false, 'O.S. não encontrada!!')
      history('../home')
    })
  }, [id])

  // verifica acessos do usuario
  useEffect(() => {

    const user: any = localStorage.getItem('user');
    const { role, branch } = JSON.parse(user);

    //steps
    const stepImobiliario = [
      {
        'number': 1,
        'text': 'Registro',
        'component': <RegistroImovel data={data} handleSelectChange={handleSelectChange} handleInputChange={handleInputChange} setData={setData} />
      },
      {
        'number': 2,
        'text': 'Vistoria',
        'component': <VistoriaImovel data={data} handleSelectChange={handleSelectChange} handleInputChange={handleInputChange} setData={setData} />
      },
      {
        'number': 3,
        'text': 'Conclusão',
        'component': <Conclusao data={data} handleSelectChange={handleSelectChange} handleInputChange={handleInputChange} setData={setData} />
      }
    ]
    const stepDataLimit = [
      {
        'number': 1,
        'text': i18n.t<string>('edit.registry'),
        'component': <Registro data={data} handleSelectChange={handleSelectChange} handleInputChange={handleInputChange} setData={setData} />
      },
      {
        'number': 2,
        'text': i18n.t<string>('edit.local search'),
        'component': <Croqui data={data} handleSelectChange={handleSelectChange} handleInputChange={handleInputChange} setData={setData} />
      },
      {
        'number': 3,
        'text': i18n.t<string>('edit.conclusion'),
        'component': <Conclusao data={data} handleSelectChange={handleSelectChange} handleInputChange={handleInputChange} setData={setData} />
      }
    ]
    const stepDataFull = [
      {
        'number': 1,
        'text': i18n.t<string>('edit.registry'),
        'component': <Registro data={data} handleSelectChange={handleSelectChange} handleInputChange={handleInputChange} setData={setData} />
      },
      {
        'number': 2,
        'text': i18n.t<string>('edit.social networks'),
        'component': <Pesquisas data={data} setData={setData} />
      },
      {
        'number': 3,
        'text': i18n.t<string>('edit.interviews'),
        'component': <Entrevista data={data} handleSelectChange={handleSelectChange} handleInputChange={handleInputChange} />
      },
      {
        'number': 4,
        'text': i18n.t<string>('edit.local search'),
        'component': <Croqui data={data} handleSelectChange={handleSelectChange} handleInputChange={handleInputChange} setData={setData} />
      },
      {
        'number': 5,
        'text': i18n.t<string>('edit.public agencies'),
        'component': <Orgaos data={data} handleSelectChange={handleSelectChange} handleInputChange={handleInputChange} setData={setData} />
      },
      {
        'number': 6,
        'text': i18n.t<string>('edit.conclused'),
        'component': <Conclusao data={data} handleSelectChange={handleSelectChange} handleInputChange={handleInputChange} setData={setData} />
      },
      {
        'number': 7,
        'text': i18n.t<string>('edit.expenses'),
        'component': <Despesas data={data} handleSelectChange={handleSelectChange} handleInputChange={handleInputChange} setData={setData} />
      }
    ]

    if (branch === 'imobiliario') {
      setStepData(stepImobiliario)
    } else if (role === 'user') {
      setStepData(stepDataLimit)
    } else {
      setStepData(stepDataFull)
    }
  }, [data])

  //atualiza variavel com dados dos select
  const handleSelectChange = (name: string, value: any) => {
    setData({ ...data, [name]: value });
  }

  //atualiza variavel com dados dos inputs
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setData({ ...data, [name]: value });
  };

  // submit
  const handleSubmit = (event: ChangeEvent<HTMLFormElement>, finalizado?: boolean) => {
    event.preventDefault();
    const user: any = localStorage.getItem('user');
    const { id } = JSON.parse(user);

    const progresso = {
      registro: data?.sindicancia ? !!data?.sindicancia || data?.sinistro : false,
      redesSociais: data?.redesSociais ? !!data?.redesSociais.relato : false,
      entrevista: !!data?.profissaoSegurado || !!data?.segConvivioComercial || !!data?.segConvivioResidencial,
      croqui: data?.relatoCroqui ? !!data?.relatoCroqui : false,
      orgaosPublicos: data?.relatoOrgaos ? !!data?.relatoOrgaos : false,
      conclusao: data.conclusao ? !!data.conclusao : false,
    }

    if (finalizado) {
      swal({
        title: 'Tem certeza que deseja finalizar O.S. ?',
        buttons: [
          'Não, apenas salvar!',
          'Sim, finalizar!'
        ],
        dangerMode: true,
        icon: 'info'
      }).then(function (isConfirm: any) {
        const finalizado_new = isConfirm;
        updateOs({ ...data, finalizado: finalizado_new, progresso }).then((res: any) => {
          if (finalizado_new) {
            Alert(true, 'O.S. finalizada com sucesso!')
            history('../home');
          } else {
            Alert(true, 'O.S. salva com sucesso!')
          }
        }).catch((err: any) => {
          Alert(false, 'Ocorreu um erro ao salvar O.S.')
        })
      })
    } else {
      updateOs({ ...data, progresso }).then((res: any) =>
        Alert(true, 'O.S. salva com sucesso!')
      ).catch((err: any) => {
        Alert(false, 'Ocorreu um erro ao salvar O.S.')
      })
    }


  }

  //Exibe o component da etapa selecionada
  const showComponent = (stepNumber: number) => {
    const stepCurrent = stepData.find((a) => a.number === stepNumber)
    return stepCurrent?.component
  }


  return (
    <Template path={i18n.t<string>('menu.processes')}>
      <div className='container'>
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-3'>
              <div className='container-box'>
                <h5>{i18n.t<string>('edit.process steps')}</h5>
                <hr />
                <ul>
                  {
                    stepData && stepData.map((step, index) =>
                      <li key={index} onClick={() => setActive(step.number)}>
                        <StepCard step={step} state={active} ></StepCard>
                      </li>
                    )
                  }
                </ul>
                <a href={`/relato/${id}`} target='_blank' >

                  <button className="btn btn-sm btn-secundary" >
                    Visualizar relato
                </button>
                </a>
              </div>
            </div>
            <div className='col-md-9'>
              {showComponent(active)}
              {(active === 6) ?
                <button className='btn btn-primary' onClick={(event: any) => handleSubmit(event, true)}>{i18n.t<string>('edit.finish')}</button>
                :
                <button className='btn btn-primary' onClick={(event: any) => handleSubmit(event)}>{i18n.t<string>('edit.to save')}</button>
              }
            </div>
          </div>
        </div>
      </div>
    </Template>
  )
}

export const StepCard = (props: any) => {
  return (
    <div className="edit-step">
      <span className={(props.state == props.step.number) ? 'step-number--active me-2' : 'step-number me-2'}>{props.step.number}</span>
      <label className={(props.state == props.step.number) ? 'step-text--active ms-2' : 'step-text ms-2'}>{props.step.text}</label>
    </div>
  )
}